import { render, staticRenderFns } from "./ComplianceDetails.vue?vue&type=template&id=0210b70b&scoped=true"
import script from "./ComplianceDetails.vue?vue&type=script&lang=js"
export * from "./ComplianceDetails.vue?vue&type=script&lang=js"
import style0 from "./ComplianceDetails.vue?vue&type=style&index=0&id=0210b70b&prod&scoped=true&lang=css"
import style1 from "./ComplianceDetails.vue?vue&type=style&index=1&id=0210b70b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0210b70b",
  null
  
)

export default component.exports